import View from './view';
import i18n from '../i18n';

import { upload } from '../http/requests';
import { read } from '../utils/file';





let ifn; i18n.then( i => ifn = i );

export default View.extend( {

    serialize() {
        const { bindProperty, type, name, disabled, enabled, } = this.options;
        return { 
            bindProperty, type, name, disabled, enabled,
            'messages-for': this.options['messages-for'] 
        };
    },

    events: {

        'click .-attach'() {
            const { accept, } = this.options;

            Backbone.$( `<input type="file" name="file" accept="${accept}" style="visibility:hidden;height:0;">` )
                .appendTo( document.body )
                .on( 'change', ({ target: { files: [binaryFile] } }) =>
                    read( binaryFile ).then( ({ binaryFile, width, height }) => {
                        if (!~accept.indexOf( binaryFile.type ))
                            return alert( ifn( 'errors::unacceptable file format',
                                { format: accept } ) );

                        if (this.options['max-width'])
                            if (width > this.options['max-width'])
                                return alert( ifn( 'errors::image dimension exceeded',
                                    { width: this.options['max-width'], height: this.options['max-height'] } ) );

                        if (this.options['max-height'])
                            if (height > this.options['max-height'])
                                return alert( ifn( 'errors::image dimension exceeded',
                                    { width: this.options['max-width'], height: this.options['max-height'] } ) );

                        this.model.set( this.options.bindProperty, binaryFile );

                        binaryFile.upload = upload( binaryFile )
                            .then( response => response.name )
                            .catch( () => Promise.reject( ['Upload error', this.options['messages-for'] || this.options.bindProperty] ) );
                    }, (/* e */) =>
                        alert( ifn( 'errors::cannot read file' ) ) ) )
                .click();
        },

    },

    bindingFilters: {

        typeicon(file) {
            return file instanceof File
                ? file
                : `department_icons/${file}`;
        },

        priorityicon(file) {
            return file instanceof File
                ? file
                : `news_category/${file}`;
        }

    },

    bindingHandlers: {

        filesource: {

            set($el, file) {
                $el[0].src = file instanceof File
                    ? `data: image/jpeg; base64, ${btoa( file.content )}`
                    : `/department_files/${file}`;
            },

            get() { return {}; }

        },

    },

} );



// WEBPACK FOOTER //
// ./src/js/view/field.file.js